import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'getting-paid';

export const loadData = (params, search) => dispatch => {
  const pageAsset = { GettingPaid: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
